import request from '../utils/fetch'
export function addQuestions (data) {
  return request({
    url: '/admin/askQuestions/add',
    method: 'get',
    requestBody: 'query',
    loading: true,
    params: data
  })
}
export function getQuestions (data) {
  return request({
    url: '/admin/askQuestions/get',
    method: 'get',
    requestBody: 'query',
    loading: true,
    params: data
  })
}
export function delQuestions (data) {
  return request({
    url: '/admin/askQuestions/del',
    method: 'get',
    requestBody: 'query',
    loading: true,
    params: data
  })
}
export function updateQuestions (data) {
  return request({
    url: '/admin/askQuestions/update',
    method: 'get',
    requestBody: 'query',
    loading: true,
    params: data
  })
}


